import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { saveBookInLocalStorage } from "../book/utils";
import { doSetActiveChapterId } from "../redux/reducers";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  color: ${props => props.theme.colors.primaryDarkMoreLighter};
  padding: 12px 20px;
  font-weight: 300;
  font-size: ${props => props.theme.fontSizes.sm};
  cursor: pointer;
  transition: all 0.15s ease-out;
  background: ${props =>
    props.activeChapterId ? props.theme.colors.primaryDarkDim : "transparent"};
  &:hover {
    color: rgba(255, 255, 255, 0.85);
    background: ${props => props.theme.colors.primaryDarkDim};
  }
`;

class Chapter extends Component {
  static propTypes = {
    chapter: PropTypes.object.isRequired,
    onMainMenuToggle: PropTypes.func.isRequired,
    onSetActiveChapterId: PropTypes.func.isRequired
  };

  onClick = () => {
    const {
      book,
      chapter,
      onSetActiveChapterId,
      onMainMenuToggle
    } = this.props;

    onSetActiveChapterId(chapter.id);
    saveBookInLocalStorage(book);

    // close the menu
    onMainMenuToggle();
  };

  render() {
    const { chapter, book } = this.props;
    return (
      <Wrapper
        activeChapterId={chapter.id === book.activeChapterId}
        onClick={this.onClick}
      >
        {chapter.title}
      </Wrapper>
    );
  }
}

Chapter.propTypes = {
  chapter: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  book: state.book
});

const mapDispatchToProps = dispatch => ({
  onSetActiveChapterId: id => dispatch(doSetActiveChapterId(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(Chapter);



// WEBPACK FOOTER //
// ./src/menu/Chapter.js